
function CheckSVG() {
  return (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.2505 1L3.77515 8.40039L1 5.62524" stroke="#007877" strokeWidth="1.27194" strokeMiterlimit="10" strokeLinecap="square"/>
    </svg>
  )
}

export default CheckSVG
